var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getContext } from '../../../config';
import { mapError, mapLog } from '../../../utils/logger';
import { getTrackParams, getTrackResponse, trackHttp, } from '../../../utils/ubt';
function adapter(request, responseCallback) {
    var baseParams = {
        method: request.method,
        url: request.url,
        header: request.headers,
        data: request.body,
        timeout: request.timeout,
        dataType: 'text',
        responseType: request.responseType,
    };
    var trackParams = getTrackParams(baseParams);
    var params = __assign(__assign({}, baseParams), { success: function (res) {
            responseCallback({
                statusCode: res.statusCode,
                responseText: res.data,
                headers: res.header,
                statusMessage: res.errMsg,
            });
            trackParams.success(getTrackResponse(res));
            mapLog('wechat adapter success', [res]);
        }, fail: function (res) {
            responseCallback({
                statusCode: res.statusCode || 0,
                statusMessage: res.errMsg,
            });
            trackParams.fail(res);
            mapError('wechat adapter fail', res);
        } });
    trackHttp(trackParams);
    var context = getContext();
    context.request(params);
}
export default adapter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid3guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29yZS9yZXF1ZXN0L2h0dHAvYWRhcHRlci93eC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQVNBLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUM3QyxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBQ3pELE9BQU8sRUFDTCxjQUFjLEVBQ2QsZ0JBQWdCLEVBQ2hCLFNBQVMsR0FDVixNQUFNLG9CQUFvQixDQUFDO0FBa0I1QixTQUFTLE9BQU8sQ0FDZCxPQUF5QixFQUN6QixnQkFBeUM7SUFFekMsSUFBTSxVQUFVLEdBQUc7UUFDakIsTUFBTSxFQUFFLE9BQU8sQ0FBQyxNQUFNO1FBQ3RCLEdBQUcsRUFBRSxPQUFPLENBQUMsR0FBRztRQUNoQixNQUFNLEVBQUUsT0FBTyxDQUFDLE9BQU87UUFDdkIsSUFBSSxFQUFFLE9BQU8sQ0FBQyxJQUFJO1FBQ2xCLE9BQU8sRUFBRSxPQUFPLENBQUMsT0FBTztRQUN4QixRQUFRLEVBQUUsTUFBTTtRQUNoQixZQUFZLEVBQUUsT0FBTyxDQUFDLFlBQVk7S0FDbkMsQ0FBQztJQUNGLElBQU0sV0FBVyxHQUFHLGNBQWMsQ0FBQyxVQUFVLENBQUMsQ0FBQztJQUMvQyxJQUFNLE1BQU0seUJBQ1AsVUFBVSxLQUNiLE9BQU8sWUFBQyxHQUFlO1lBQ3JCLGdCQUFnQixDQUFDO2dCQUNmLFVBQVUsRUFBRSxHQUFHLENBQUMsVUFBVTtnQkFDMUIsWUFBWSxFQUFFLEdBQUcsQ0FBQyxJQUFJO2dCQUN0QixPQUFPLEVBQUUsR0FBRyxDQUFDLE1BQU07Z0JBQ25CLGFBQWEsRUFBRSxHQUFHLENBQUMsTUFBTTthQUMxQixDQUFDLENBQUM7WUFDSCxXQUFXLENBQUMsT0FBTyxDQUFDLGdCQUFnQixDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7WUFDM0MsTUFBTSxDQUFDLHdCQUF3QixFQUFFLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztRQUMxQyxDQUFDLEVBQ0QsSUFBSSxZQUFDLEdBQWU7WUFDbEIsZ0JBQWdCLENBQUM7Z0JBQ2YsVUFBVSxFQUFFLEdBQUcsQ0FBQyxVQUFVLElBQUksQ0FBQztnQkFDL0IsYUFBYSxFQUFFLEdBQUcsQ0FBQyxNQUFNO2FBQzFCLENBQUMsQ0FBQztZQUNILFdBQVcsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7WUFDdEIsUUFBUSxDQUFDLHFCQUFxQixFQUFFLEdBQUcsQ0FBQyxDQUFDO1FBQ3ZDLENBQUMsR0FDRixDQUFDO0lBQ0YsU0FBUyxDQUFDLFdBQVcsQ0FBQyxDQUFDO0lBQ3ZCLElBQU0sT0FBTyxHQUFHLFVBQVUsRUFBRSxDQUFDO0lBQzdCLE9BQU8sQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUM7QUFDMUIsQ0FBQztBQUVELGVBQWUsT0FBTyxDQUFDIn0=